var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.6744V7.32558C0 3.29412 3.26616 0 7.26342 0H20.499C24.4962 0 27.7624 3.29412 27.7624 7.32558V20.6744C27.7624 24.7059 24.4962 28 20.499 28H16.046L13.7198 27.4254L11.7164 28H7.26342C3.26616 28 0 24.7059 0 20.6744Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2837 18.5105L19.9009 14.4599H16.046V11.8361C16.046 10.7253 16.5872 9.65277 18.3058 9.65277H20.0528V6.20544C20.0528 6.20544 18.4672 5.92773 16.948 5.92773C13.7768 5.92773 11.707 7.86207 11.707 11.3764V14.4599H8.18445V18.5105H11.707V28.0002H16.046V18.5105H19.2837Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebookLogo.0ecb0dd5e0b2b32e7dfda84402e71967.svg";
export { ForwardRef as ReactComponent };